import { AppDispatch } from "redux/store";
import { onGetUserInfo } from "./onGetUserInfo";
import { User } from "@auth0/auth0-react";
import { message } from "antd";

export const getFilenameFromContentDisposition = (headers: any) => {
    const contentDisposition = headers["content-disposition"];
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=["']?([^"']+)/);
        if (filenameMatch && filenameMatch[1]) {
            return filenameMatch[1];
        }
    }
    // If the header is not present or doesn't contain a filename, use a default name
    return "downloaded-file.pdf";
};

export const DownloadFile = (arrayBuffer: any, filename: string) => {
    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}`;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

export const onDownloadFax = async (
  data: any,
  path: string,
  dispatch: AppDispatch,
  user: User | undefined,
  navigation: (path: string) => void
) => {
  await onGetUserInfo(dispatch, user, navigation);
  const accessToken = localStorage.getItem("accessToken");
  try {
    const response = await fetch(path, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (response.ok) {
      const responseArrayBuffer = await response.arrayBuffer();
      DownloadFile(responseArrayBuffer, data?.friendly_name);
    }  else {
        message.error("Sorry, we couldn't download that document");
    }
  } catch (error) {
    console.error("Error:", error);
    message.error("Sorry, we couldn't download that document");
  }
};
